import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { HttpService, ServiceEndpoints } from '@/config/NextImport'

const initialState: any = {
  message: '',
  settingOptions: [],
  status: false
}

export const getSettingOptions = createAsyncThunk('setting/getSettingOptions', async () => {
  const response = await HttpService.getApi(ServiceEndpoints.getSettingOptions)
  return response
})

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSettingOptions.fulfilled, (state, action) => {
      state.settingOptions = action.payload.result
      state.message = action.payload.message
      state.status = action.payload.status
    })
  }
})

export default settingSlice.reducer
